<template>
    <div>
        <vx-card>
            <div class="font-bold mb-4">FILTROS</div>
            <a-cascader v-model="filter.categoryFilter" :options="cascadeFilter"
                :disabled="disabled"
                change-on-select expand-trigger="hover" size="large"
                :show-search="{ filter: filterCascader }"
                placeholder="Filtrar por Menu/Categoria" class="w-full" />
            <vs-divider />
            <div class="mt-4">
                <b class="mr-4">Status:</b>
                <a-radio-group v-model="filter.status" 
                    button-style="solid" :disabled="disabled">
                    <a-radio-button value="all">
                        Todos
                    </a-radio-button>
                    <a-radio-button value="active">
                        Ativo
                    </a-radio-button>
                    <a-radio-button value="inactive">
                        Pausado
                    </a-radio-button>
                </a-radio-group>
            </div>
        </vx-card>

        <StatisticCard hideChart
            class="mt-6 sm:hidden md:block"
            icon-right
            :statistic="totalPaused"
            statisticTitle="Produtos pausados"
            icon="PauseIcon"/>
        <StatisticCard hideChart v-if="products"
            class="mt-5 sm:hidden md:block"
            icon-right
            :statistic="products.length"
            statisticTitle="Produtos no total"
            icon="ActivityIcon" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import StatisticCard from '../../components/statistics-cards/StatisticCard';
    import util from '@/assets/utils/misc'

    export default {
        components: {StatisticCard},
        props: {
            value: Object,
            products: Array
        },
        computed: {
            filter: {
                get () { return this.value; },
                set (v) { this.$emit('input', v); }
            },
            disabled () {
                return !this.menus?.length || !this.productTypes?.length;
            },
            cascadeFilter () {
                if (this.disabled)
                    return [];
                return this.menus.map(m => {
                    return { 
                        label: m.description,
                        value: m.id,
                        children: this.productTypes.filter(pt => pt.menu == m.id).map(pt => {
                            return {
                                label: pt.description,
                                details: pt.details,
                                value: pt.id,
                            }
                        })
                    };
                }).filter(m => m.children.length);
            },
            totalPaused () { return this.products.filter(p => p.enabled === false).length; },
            ...mapGetters('productType', { 'productTypes': 'productTypesOrderedByMenu', 'menus': 'companyMenus' }),
        },
        methods: {
            filterCascader (inputValue, path) {
                return path.some(option => util.removeSpecialChars(option.label).includes(util.removeSpecialChars(inputValue)));
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>